import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import useNotifications from '../../../../hooks/useNotifications'
import { registerKiosk } from '../../../../services/templeKioskService'

export default function useRegisterKiosk({ overlay, onSuccess }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()
  const [templeCode, setTempleCode] = useState('')
  const [kioskId, setKioskId] = useState('')
  const [serialNumber, setSerialNumber] = useState('')
  const [locationType, setLocationType] = useState('TEMPLE')
  const [locationDescription, setLocationDescription] = useState('')
  const [langCode, setLangCode] = useState('en')
  const state = {
    templeCode,
    kioskId,
    serialNumber,
    locationType,
    locationDescription,
    langCode,
  }
  const actions = {
    setTempleCode,
    setKioskId,
    setSerialNumber,
    setLocationType,
    setLocationDescription,
    setLangCode,
  }

  const submitOnClick = async () => {
    overlay.close()
    await registerKiosk({
      templeCode,
      kioskId,
      serialNumber,
      locationType,
      locationDescription,
      langCode,
    })
      .then(() => {
        ok(t('success', 'Success'))
        setTempleCode('')
        setKioskId('')
        setSerialNumber('')
        setLocationType('TEMPLE')
        setLocationDescription('')
        setLangCode('en')
        onSuccess && onSuccess(kioskId)
      })
      .catch((err) => {
        error(
          t('kiosk.register.error', 'Error registering kiosk: {message}', {
            message: err.message || '',
          }),
          err
        )
      })
  }
  return { submitOnClick, state, actions }
}
